/**
 * sockjs-client (via browser-crypto.js) expects Node's `global`.
 * Browser bundles (esbuild) do not define it — set before app or lazy chunks load.
 */
const g = globalThis as typeof globalThis & { global?: typeof globalThis };
if (g.global === undefined) {
  g.global = globalThis;
}
